import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import QuickAdd from "@/pages/QuickAdd";
import History from "@/pages/History";
import Accounts from "@/pages/Accounts";
import ImportPage from "@/pages/Import";
import Invoices from "@/pages/Invoices";
import Rules from "@/pages/Rules";
import Detections from "@/pages/Detections";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        A carregar…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/registar" element={<QuickAdd />} />
        <Route path="/historico" element={<History />} />
        <Route path="/contas" element={<Accounts />} />
        <Route path="/importar" element={<ImportPage />} />
        <Route path="/faturas" element={<Invoices />} />
        <Route path="/deteccoes" element={<Detections />} />
        <Route path="/regras" element={<Rules />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
